import React from 'react';
import classNames from 'classnames';
import Icon, { COLORS, ICONS } from '../icon';
import { Alert, ALERT_TYPES } from '../alert-types';

function parseType(type: ALERT_TYPES) {
	switch (type) {
		case ALERT_TYPES.WARNING:
			return 'warning';
		case ALERT_TYPES.ERROR:
			return 'error';
		case ALERT_TYPES.NEUTRAL:
			return 'neutral';
		case ALERT_TYPES.POSITIVE:
			return 'positive';
		case ALERT_TYPES.CHAT:
			return 'chat';
		case ALERT_TYPES.MEDIA_DEVICE:
			return 'media-device';
		case ALERT_TYPES.MEDIA_UPLOADED:
			return 'media-uploaded';
		case ALERT_TYPES.MEDIA_TITLE_ERROR:
			return 'media-title-error';
		case ALERT_TYPES.PRESENTER_CAP:
			return 'presenter-cap';
		default:
			return 'neutral';
	}
}

interface OwnProps {
	alert: Alert
	onClick?: (e?: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
	children?: React.ReactNode,
	alertStyle?: React.CSSProperties
	containerStyle?: React.CSSProperties
}

export default function AlertBasic (props: OwnProps) {
	const {
		alert,
		onClick,
		children = <></>,
		alertStyle = {},
		containerStyle = {}
	} = props;


	return <div 
		style={{...containerStyle}}
		className={classNames('alerts-container', {
			'auto-width': alert.autoWidth,
		})}
	>
		<div
			onClick={onClick}
			style={{...alertStyle}}
			className={classNames('alert show', parseType(alert.type),
				// alert.animationState, 
				{
					clickable: !!onClick
				}
			)}
		>
			{alert.type === ALERT_TYPES.ERROR
				&& <div className="media-device-error-icon sad">
					<Icon name={ICONS.ERROR} color={COLORS.WHITE} size={24} />
				</div>
			}
			{alert.type ===   ALERT_TYPES.WARNING
				&& <div className="media-device-error-icon sad">
					<Icon name={ICONS.INFO_CIRCLE} color={COLORS.WHITE} size={20} />
				</div>
			}
			{alert.type ===  ALERT_TYPES.NEUTRAL
				&& <div className="notification-icon blue">
					<Icon name={ICONS.CHAT_NOTIFICATION} color={COLORS.WHITE} size={24} />
				</div>
			}

			<div className="alert-content">
				<h6 className="alert-title bl-font-header margin-none">{alert.message}</h6>

				{alert.description ? (
					<div className="alert-description-wrap bl-font-p2">{alert.description}</div> 
				) : null}

				{alert.buttonText ? (
					<div className="alert-buttons">
						<button className="xsmall">{alert.buttonText}</button>
					</div>
				) : null}

				{children}
			</div>

		</div>
	</div>
}
